/* 🤖 this file was generated by svg-to-ts*/
export const icoCss3: {
  name: 'css-3';
  data: string;
} = {
  name: 'css-3',
  data: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 3h16l-1.613 16.177L12 21l-6.386-1.824L4 3zm12.9 3.424l-9.8-.002.158 1.949 7.529.002-.189 2.02H9.66l.179 1.913h4.597l-.272 2.62-2.164.598-2.197-.603-.141-1.57h-1.94l.216 2.868L12 17.484l3.995-1.137.905-9.923z" fill="#909090"/></svg>`
};
